import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../services/settings.service';

export function useCompany() {
  return useQuery({
    queryKey: ['company'],
    queryFn: () => settingsService.getCompany(),
  });
}
